export default function init_nav_menu(){

    document.querySelectorAll('.main_menu .menu-item-has-children').forEach(li=>{
        init_hover_class(li);
        disable_link(li);
    })
}

function init_hover_class(li){

    const hover_class = 'open_sub';

    const a = li.children[0];
    
    let hover_out_timeout = null;

    a.addEventListener('pointerenter', ()=>{
        clearTimeout(hover_out_timeout);
        li.classList.add(hover_class);
    });

    a.addEventListener('pointerleave', ()=>{
        clearTimeout(hover_out_timeout);
        hover_out_timeout = setTimeout(()=>{
            li.classList.remove(hover_class);
        }, 400);
    });
}

function disable_link(li){
    const a = li.children[0];
    a.addEventListener('click', e=>{
        e.preventDefault();
    })
}